var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoiceWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Invoice"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Invoice",
    clipPath: "url(#clip-Invoice)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3657",
    "data-name": "Group 3657",
    transform: "translate(-0.005 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5920",
    "data-name": "Path 5920",
    d: "M9.331,15.42a6.087,6.087,0,1,1,.009,0Zm0-13.321A7.229,7.229,0,1,0,16.56,9.328h0A7.225,7.225,0,0,0,9.34,2.1Z",
    transform: "translate(-0.337 -0.337)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5921",
    "data-name": "Path 5921",
    d: "M9.76,5.314A4.445,4.445,0,1,0,14.209,9.76,4.446,4.446,0,0,0,9.76,5.314Zm0,9.355a4.91,4.91,0,1,1,4.91-4.91A4.909,4.909,0,0,1,9.76,14.669Z",
    transform: "translate(-0.778 -0.778)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5922",
    "data-name": "Path 5922",
    d: "M8.994,17.983A8.986,8.986,0,0,1,.688,12.432a9,9,0,0,1,0-6.882A8.991,8.991,0,0,1,16.471,4,9.091,9.091,0,0,1,17.3,5.55a9,9,0,0,1,0,6.882A8.992,8.992,0,0,1,8.99,17.983ZM8.994.74A8.272,8.272,0,1,0,10.6.9,8.273,8.273,0,0,0,8.994.74Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5923",
    "data-name": "Path 5923",
    d: "M12.125,8.8h-.858a1.692,1.692,0,0,0-.678-1.184h1.536a.169.169,0,0,0,.023-.338h-3.6a.169.169,0,0,0,0,.338H9.574A1.366,1.366,0,0,1,10.925,8.8H8.546a.169.169,0,0,0,0,.338h2.379a1.369,1.369,0,0,1-1.351,1.2H8.549a.171.171,0,0,0-.116.3l2.558,2.419a.169.169,0,0,0,.238-.007h0a.172.172,0,0,0-.007-.238l-2.25-2.129h.6a1.709,1.709,0,0,0,1.7-1.539h.858a.169.169,0,0,0,.023-.338h-.023Z",
    transform: "translate(-1.344 -0.84)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceWhite);
export default __webpack_public_path__ + "static/media/Invoice-white.27c60600ec98bddf6c684bf67c50551a.svg";
export { ForwardRef as ReactComponent };